import React, { Component } from 'react';
import { func, shape, string } from 'prop-types';
import DualButtons from 'components/DualButtons';
import InputWithValidation from 'components/InputWithValidation';
import { required, maxLength } from 'helpers/validate';
import { validateForm } from 'helpers/validateForm';
import {
  ShipmentFilterNameValidationMessage,
} from 'constants/messagesAndDescriptions';
import { event as gaEvent } from 'react-ga';
import Header from 'components/CardShell/Header';
import styles from './styles.scss';

const validationRules = {
  name: [
    required(),
    maxLength(
      50,
      () => ShipmentFilterNameValidationMessage,
    ),
  ],
};

class NameGroup extends Component {
  static propTypes = {
    formData: shape({
      name: string,
    }).isRequired,
    updateState: func.isRequired,
    gotoPage: func.isRequired,
    cancel: func.isRequired,
    title: string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      errors: null,
    };
  }

  handleNextButtonClick = () => {
    const errors = validateForm(validationRules, this.props.formData);
    if (errors.hasErrors) {
      this.setState({ errors });
      return;
    }

    this.props.gotoPage(1);
  };

  render() {
    const {
      formData,
      updateState,
      cancel,
      pageTabs,
      title,
    } = this.props;

    return (
      <div className={styles.cardSection}>
        <div className={styles.cardSectionNav}>
          {pageTabs()}
        </div>
        <div className={styles.cardSectionInner}>
          <Header>{title}</Header>
          <InputWithValidation
            label="Shipment Filter Name"
            placeholder="Shipment event filter name"
            type="text"
            value={formData.name}
            name="name"
            onChange={(event) => {
              gaEvent({
                category: 'ShipmentFilters',
                action: 'Name',
              });
              updateState({ name: event.target.value });
            }}
            errors={this.state.errors}
            required
          />
        </div>
        <div className={styles.cardSectionButtons}>
          <DualButtons
            leftFunction={() => cancel()}
            leftText="Cancel"
            rightFunction={this.handleNextButtonClick}
            rightText="Next"
            theme="rightPink"
            rightFunctionDisabled={formData.name.length < 1}
          />
        </div>
      </div>
    );
  }
}

export default NameGroup;
